import { request } from '@/utils/request'
import { translate as translateErrors } from '@/utils/validation'

export function getProviderCompany(providerId, providerEntityId) {
    return request.get(`/api/manage/providers/${providerId}/companies/${providerEntityId}`)
}
export function searchProviderCompanies(providerId, query, limit, includeExisting) {
    return request.get(`/api/manage/providers/${providerId}/companies/search`, {
        query,
        'page.limit': limit,
        includeExisting: includeExisting ?? false,
    })
}

const CompanyService = {
    props: {
        id: {
            required: true,
        },
    },
    get(id) {
        return request.get(`/api/manage/companies/${id}`)
    },
    update(id, company) {
        return request.put(`/api/manage/companies/${id}`, company)
    },
    async insert(company) {
        const response = await request.post('/api/manage/companies', company)
        if (response.status === 422) {
            translateErrors(response.content)
        }
        return response
    },
    import(factSetEntityId, tracked, tags) {
        return request.post(`/api/manage/companies/import`, { factSetEntityId, tracked, tags })
    },
    getProviderCompany,
    searchParagonCompanies(query, limit, offset, includeUntracked) {
        return request.get('/api/manage/companies/search', {
            query,
            'page.limit': limit,
            'page.offset': offset,
            includeUntracked,
        })
    },
    searchProviderCompanies,
}

export default CompanyService
